var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imagePath && _vm.imagePath.length > 0)?_c('img',{ref:"image",class:_vm.behavior,style:(_vm.imageStyle),attrs:{"id":"image"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }